import {Languages} from "../../data/Languages.config";
import DropdownButton from "./DropdownButton";
import {i18n, useTranslation} from "next-i18next";
import {useRouter} from "next/router";
import IconSprache from "../../data/Icons/leon-inmobiliaria-icons-sprache.svg";
import LogoLang from "../../data/Icons/logo_leon_lang_final.svg";
// import LogoCompact from "../../data/Icons/logo_leon_final_weiss.svg";
import IconBurgerMenu from "../../data/Icons/leon-inmobiliaria-icons-burger.svg";
import IconLogin from "../../data/Icons/leon-inmobiliaria-icons-login.svg";
import Link from "next/link";
import Button from "./Button";
import DesktopNavigation from "./DesktopNavigation";
import Image from "next/image";

export default function CompanyHeader(props: {
	scrolledStyle: boolean;
	color?: string;
	onToggleMobileMenu: (open: boolean) => void;
	open?: boolean;
	headerNotTransparent?: boolean;
	hasScrolledDown?: boolean;
	hasShadow?: boolean;
}) {
	const router = useRouter();
	const {t} = useTranslation();
	const {pathname, asPath, query} = router;
	const languageNames: Record<string, string> = {
		de: "Deutsch",
		en: "English",
		fr: "Français",
		nl: "Nederlands",
		ru: "Русский",
		es: "Español",
		ca: "Català",
		ua: "Українська"
	};



	return (
		<div>
			<div
				className={`justify-between items-center lg:px-20 px-5 transition  duration-300 relative ${
					props.scrolledStyle ? "bg-white" : "bg-transparent"
				}${(props.open ?? false) ? " hidden" : " flex"}`}
			>
				{props.hasShadow && (
					<div className={`absolute top-0 left-0 w-full -z-[1] h-28 bg-gradient-to-b from-black/60 to-transparent
						${
							props.scrolledStyle ? "hidden" : "block"
						}
					`} />
				)}
				<Link href={"/"}>
					{props.scrolledStyle && (
						<div
							className={`my-6 transition duration-300 ${
								props.scrolledStyle ? "lg:w-80 w-36" : "w-0"
							}`}
						>
							<LogoLang/>
						</div>
					)}
					{!props.scrolledStyle && (
						<div
							className={`mb-5 mt-7 transition duration-300 ${
								props.scrolledStyle ? "w-0" : "2xl:w-32 w-24 m-2"
							}`}
						>
							<Image
								src="/images/LEON-Logo-weiss-orange-auf-transparent.png"
								title="LEON"
								alt="LEON"
								className=""
								width={130}
								height={72}
							/>
						</div>
					)}
				</Link>
				<DesktopNavigation
					color={props.color}
					scrolledStyle={!props.headerNotTransparent ? props.hasScrolledDown ?? false : true}
				/>
				<div className="hidden items-center lg:flex gap-1">
					<Button
						href="https://account.leon-inmobiliaria.com"
						text={t("components.companyHeader.login")}
						height="h-8 text-[12px]"
						transparent={true}
						border={false}
						className="uppercase font-bold"
						textTransform="uppercase"
						textColor={
							props.scrolledStyle
								? "text-leo-button-gray"
								: props.color
									? `text-[${props.color}]`
									: undefined
						}
						bgColor="bg-transparent"
					/>
					<Image
						quality={90}
						src="/images/locale_icon.png"
						alt=""
						width={50}
						height={25}
						className={`${props.scrolledStyle ? "hidden" : "inline-block"} w-[50px] h-[25px]`}
					/>
					<DropdownButton
						minWidth=""
						textAlign="text-left"
						border={false}
						className="uppercase font-bold"
						hoverTextColor="hover:text-leo-orange"
						stretchButtonWidth={false}
						endAdornmentSpaceBetween={true}
						buttonHeight="h-8 gap-0"
						transparent={true}
						text={i18n?.language ? languageNames[i18n?.language]?.toUpperCase() : ""}
						subMenuItems={Languages.map((language) => {
							return {
								name: language.label,
								href: undefined,
								onClick: () => {
									router.push({pathname, query}, asPath, {
										locale: language.hreflang.toLowerCase()
									});
								}
							};
						})}
						padding="px-2"
						textColor={
							props.scrolledStyle
								? "text-leo-button-gray"
								: props.color
									? `text-[${props.color}]`
									: undefined
						}
					/>
				</div>
				<div className="flex items-center gap-1 lg:hidden pt-2">
					<Link
						href="https://account.leon-inmobiliaria.com/"
						className={`${
							props.scrolledStyle
								? "text-leo-button-gray"
								: props.color
									? `text-[${props.color}]`
									: "text-white"
						} transition duration-300`}
					>
						<p className="uppercase font-bold text-[12px]">{t("components.companyHeader.login")}</p>
					</Link>
					<Image
						quality={90}
						src="/images/locale_icon.png"
						alt=""
						width={46}
						height={23}
						className={props.scrolledStyle ? "hidden" : "inline-block"}
					/>
					<DropdownButton
						minWidth="min-w-auto"
						textAlign="text-left"
						border={false}
						className="uppercase font-bold text-[14px]"
						hoverTextColor="hover:text-leo-orange"
						stretchButtonWidth={false}
						endAdornmentSpaceBetween={true}
						buttonHeight="h-10"
						transparent={true}
						text={i18n?.language ? languageNames[i18n?.language]?.toUpperCase() : ""}
						subMenuItems={Languages.map((language) => {
							return {
								name: language.label,
								href: undefined,
								onClick: () => {
									router.push({pathname, query}, asPath, {
										locale: language.hreflang.toLowerCase()
									});
								}
							};
						})}
						padding="px-1"
						textColor={
							props.scrolledStyle
								? "text-leo-button-gray"
								: props.color
									? `text-[${props.color}]`
									: undefined
						}
					/>
					<button
						onClick={() => props.onToggleMobileMenu(true)}
						className={`w-10 ${
							props.scrolledStyle
								? "text-leo-button-gray"
								: props.color
									? `text-[${props.color}]`
									: "text-white"
						} transition duration-300`}
					>
						<IconBurgerMenu/>
					</button>
				</div>
			</div>
		</div>
	);
}
